import urls from './urls';

// #region Logon

export async function LogIn(payload) {
  return await PostJSON(urls().LogIn, payload);
}
export async function LogOut() {
  return await PostJSON(urls().LogOut, '{}');
}
export async function Register(payload) {
  return await PostJSON(urls().Register, payload);
}
export async function GetAuthenticatedUser() {
  return await GetJSON(urls().GetAuthenticatedUser);
}
export async function GetUserPurchasePlan() { 
  return await GetJSON(urls().GetUserPurchasePlan); 
}

// #endregion

export async function Export(payload) {
  return await PostJSONWithFileResponse(urls().Export, payload);
}

// #region Invoices

export async function PostInvoice(payload) {
  return await PostJSON(urls().PostInvoice, payload);
}
export async function PutInvoice(payload) {
  return await PutJSON(urls().PutInvoice, payload);
}
export async function GetInvoices(from, to, limit, offset) {
  return await GetJSON(
    urls().GetInvoices +
      '?from=' +
      encodeURIComponent(from) +
      '&to=' +
      encodeURIComponent(to) +
      '&limit=' +
      limit +
      '&offset=' +
      offset,
  );
}
export async function GetInvoicesHeaders(from, to, limit, offset) {
  return await GetJSON(
    urls().GetInvoicesHeaders +
      '?from=' +
      encodeURIComponent(from) +
      '&to=' +
      encodeURIComponent(to) +
      '&limit=' +
      limit +
      '&offset=' +
      offset,
  );
}

export async function GetInvoicesHeadersCount(from, to) {
  return await GetJSON(
    urls().GetInvoicesHeadersCount +
      '?from=' +
      encodeURIComponent(from) +
      '&to=' +
      encodeURIComponent(to)
  );
}

export async function GetInvoice(id) {
  return await GetJSON(urls().GetInvoice + '?id=' + encodeURIComponent(id));
}
export async function GetInvoiceBasedOnInvoice(id, invoiceDateUtc, timezone) {
  return await GetJSON(
    urls().GetInvoiceBasedOnInvoice +
      '?id=' +
      encodeURIComponent(id) +
      '&invoiceDateUtc=' +
      encodeURIComponent(invoiceDateUtc) +
      '&timezone=' +
      encodeURIComponent(timezone),
  );
}
export async function GetInvoiceBasedOnProforma(id, invoiceDateUtc, timezone) {
  return await GetJSON(
    urls().GetInvoiceBasedOnProforma +
      '?id=' +
      encodeURIComponent(id) +
      '&invoiceDateUtc=' +
      encodeURIComponent(invoiceDateUtc) +
      '&timezone=' +
      encodeURIComponent(timezone),
  );
}
export async function CopyInvoice(payload) {
  return await PostJSON(urls().CopyInvoice, payload);
}
export async function GetCalculatedInvoiceSummary(payload) {
  return await PostJSON(urls().GetInvoiceSummary, payload);
}
export async function UpdateInvoiceLeftToPayAmount(payload) {
  return await PostJSON(urls().UpdateInvoiceLeftToPayAmount, payload);
}
export async function DeleteInvoice(id) {
  return await DeleteJSON(urls().DeleteInvoice + '?id=' + encodeURIComponent(id));
}
export async function DeleteInvoices(ids) {
  return await DeleteJSON(urls().DeleteInvoices + '?' + ids.map(id => 'ids='+encodeURIComponent(id)).join('&'));
}

// #endregion

export async function GetNextSequenceValue(sequence) {
  return await GetJSON(urls().GetNextSequenceValue + '?sequence=' + encodeURIComponent(sequence));
}


// #region Inventory

export async function SearchProduct(searchString) {
  return await GetJSON(urls().GetProduct + '?searchString=' + encodeURIComponent(searchString) + '&limit=10');
}

export async function AddOrUpdateProduct(payload) {
  return await PutJSON(urls().PutProduct, payload);
}

// #endregion

// #region Contractors

export async function SearchContractor(searchString) {
  return await GetJSON(urls().GetContractor + '?searchString=' + encodeURIComponent(searchString) + '&limit=10');
}
export async function SearchContractorInGus(nip) {
  return await GetJSON(urls().GetContractorFromGus + '?nip=' + encodeURIComponent(nip));
}
export async function ValidateNIP(nip, countryCode) {
  return await GetJSON(
    urls().ValidateNIP + '?nip=' + encodeURIComponent(nip) + '&countryCode=' + encodeURIComponent(countryCode),
  );
}
export async function AddOrUpdateContractor(payload) {
  return await PostJSON(urls().AddOrUpdateContractor, payload);
}

// #endregion

// #region Organization

export async function PutOrganization(payload) {
  return await PutJSON(urls().PutOrganization, payload);
}
export async function GetOrganization() {
  return await GetJSON(urls().GetOrganization);
}

// #endregion

// #region Users

export async function GetInvitedUserData(token) {
  return await GetJSON(urls().GetInvitedUser + '?invitationToken=' + token);
}
export async function ValidateCaptcha(payload) {
  return await PostJSON(urls().ValidateCaptcha, payload);
}
export async function ConfirmRegistration(token) {
  return await GetJSON(urls().ConfirmRegistration + '?registrationToken=' + token);
}
export async function RegisterUser(payload) {
  return await PostJSON(urls().Register, payload);
}
export async function RegisterInvitationUser(payload) {
  return await PostJSON(urls().RegisterInvitedUser, payload);
}

export async function DeleteUser(id) {
  return await DeleteJSON(urls().DeleteUser + '?id=' + encodeURIComponent(id));
}

export async function PostUserRating(payload) {
  return await PostJSON(urls().PutUserRating, payload);
}
export async function GetUserRating() {
  return await GetJSON(urls().GetUserRating);
}

export async function GetUsers() {
  return await GetJSON(urls().GetUsers);
}
export async function SendUserInvites(payload) {
  return await PostJSON(urls().SendUserInvites, payload);
}
export async function SendResetPasswordLink(payload) {
  return await PostJSON(urls().SendResetPasswordLink, payload);
}
export async function ResetPassword(payload) {
  return await PostJSON(urls().ResetPassword, payload);
}
// #endregion

// #region Costs invoices

export async function PostCostInvoice(payload) {
  return await PostJSON(urls().PostCostInvoice, payload);
}
export async function PutCostInvoice(payload) {
  return await PutJSON(urls().PutCostInvoice, payload);
}
export async function GetCostsInvoices(from, to, limit, offset) {
  return await GetJSON(
    urls().GetCostsInvoices +
      '?from=' +
      encodeURIComponent(from) +
      '&to=' +
      encodeURIComponent(to) +
      '&limit=' +
      limit +
      '&offset=' +
      offset,
  );
}
export async function GetCostsInvoicesHeaders(from, to, limit, offset) {
  return await GetJSON(
    urls().GetCostsInvoicesHeaders +
      '?from=' +
      encodeURIComponent(from) +
      '&to=' +
      encodeURIComponent(to) +
      '&limit=' +
      limit +
      '&offset=' +
      offset,
  );
}

export async function GetCostsInvoicesHeadersCount(from, to) {
  return await GetJSON(
    urls().GetCostsInvoicesHeadersCount +
      '?from=' +
      encodeURIComponent(from) +
      '&to=' +
      encodeURIComponent(to)
  );
}

export async function GetCostInvoice(id) {
  return await GetJSON(urls().GetCostInvoice + '?id=' + encodeURIComponent(id));
}
export async function DeleteCostInvoice(id) {
  return await DeleteJSON(urls().DeleteCostInvoice + '?id=' + encodeURIComponent(id));
}
export async function DeleteCostInvoices(ids) {
  return await DeleteJSON(urls().DeleteCostInvoices + '?' + ids.map(id => 'ids='+encodeURIComponent(id)).join('&'));
}

// #endregion

// #region Attachments

export async function PostBinaryFile(name, file) {
  return await PostBinary(`${urls().AttachmentsUpload}/${encodeURIComponent(name)}`, file);
}
export async function GetBinaryFile(id, name) {
  return await GetBinary(`${urls().AttachmentDownload}/${id}/${encodeURIComponent(name)}`);
}

// #endregion

// #region Proformas

export async function PostProforma(payload) {
  return await PostJSON(urls().PostProforma, payload);
}
export async function PutProforma(payload) {
  return await PutJSON(urls().PutProforma, payload);
}
export async function GetProformas(from, to, limit, offset) {
  return await GetJSON(
    urls().GetProformas +
      '?from=' +
      encodeURIComponent(from) +
      '&to=' +
      encodeURIComponent(to) +
      '&limit=' +
      limit +
      '&offset=' +
      offset,
  );
}
export async function GetProformasHeaders(from, to, limit, offset) {
  return await GetJSON(
    urls().GetProformasHeaders +
      '?from=' +
      encodeURIComponent(from) +
      '&to=' +
      encodeURIComponent(to) +
      '&limit=' +
      limit +
      '&offset=' +
      offset,
  );
}

export async function GetProformasHeadersCount(from, to) {
  return await GetJSON(
    urls().GetProformasHeadersCount +
      '?from=' +
      encodeURIComponent(from) +
      '&to=' +
      encodeURIComponent(to)
  );
}

export async function GetProforma(id) {
  return await GetJSON(urls().GetProforma + '?id=' + encodeURIComponent(id));
}
export async function GetProformaBasedOnProforma(id, invoiceDateUtc, timezone) {
  return await GetJSON(
    urls().GetProformaBasedOnProforma +
      '?id=' +
      encodeURIComponent(id) +
      '&invoiceDateUtc=' +
      encodeURIComponent(invoiceDateUtc) +
      '&timezone=' +
      encodeURIComponent(timezone),
  );
}
export async function CopyProforma(payload) {
  return await PostJSON(urls().CopyProforma, payload);
}
export async function GetCalculatedProformaSummary(payload) {
  return await PostJSON(urls().GetProformaSummary, payload);
}
export async function UpdateProformaLeftToPayAmount(payload) {
  return await PostJSON(urls().UpdateProformaLeftToPayAmount, payload);
}
export async function DeleteProforma(id) {
  return await DeleteJSON(urls().DeleteProforma + '?id=' + encodeURIComponent(id));
}
export async function DeleteProformas(ids) {
  return await DeleteJSON(urls().DeleteProformas + '?' + ids.map(id => 'ids='+encodeURIComponent(id)).join('&'));
}

// #endregion

// #region Correction Invoices

export async function CreateCorrectionInvoice(id) {
  return await GetJSON(urls().CreateCorrectionInvoice + '?originalDocumentId=' + encodeURIComponent(id));
}
export async function RecalculateCorrectionInvoice(payload) {
  return await PostJSON(urls().RecalculateCorrectionInvoice, payload);
}

export async function GetCalculatedCorrectionInvoiceSummary(payload) {
  return await PostJSON(urls().GetCorrectionInvoiceSummary, payload);
}

export async function PutCorrectionInvoice(payload) {
  return await PutJSON(urls().PutCorrectionInvoice, payload);
}
export async function GetCorrectionInvoice(id) {
  return await GetJSON(urls().GetCorrectionInvoice + '?id=' + encodeURIComponent(id));
}
export async function DeleteCorrectionInvoice(id) {
  return await DeleteJSON(urls().DeleteCorrectionInvoice + '?id=' + encodeURIComponent(id));
}

export async function DeleteCorrectionInvoices(ids) {
  return await DeleteJSON(urls().DeleteCorrectionInvoices + '?' + ids.map(id => 'ids='+encodeURIComponent(id)).join('&'));
}

export async function UpdateCorrectionInvoiceLeftToPayAmount(payload) {
  return await PostJSON(urls().UpdateCorrectionInvoiceLeftToPayAmount, payload);
}

// #endregion

// #region Payments

export async function CalculateCartToken(payload) {
  return await PostJSON(urls().CalculateCartToken, payload);
}

// #endregion

// #region Key-Value Store

export async function UpsertKeyValueStore(key, payload) {
  return await PutJSON(urls().KeyValueStoreGlobal+'/'+key, payload);
}

// #endregion

async function GetJSON(url) {
  const requestOptions = {
    method: 'GET',
    headers: { Accept: 'application/json' },
    credentials: 'include',
  };

  const resp = await fetch(url, requestOptions);
  if (resp.status == '204') {
    return undefined;
  } else {
    return await resp.json();
  }
}

async function PostJSON(url, payload) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  };
  var resp;
  try {
    resp = await fetch(url, requestOptions);
    const json = await resp.json();
    return json;
  } catch {
    throw new Error({
      reseponseStatus: resp.status,
    });
  }
}

async function PutJSON(url, payload) {
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  };
  var resp;
  try {
    resp = await fetch(url, requestOptions);
    const json = await resp.json();
    return json;
  } catch {
    throw new Error({
      reseponseStatus: resp.status,
    });
  }
}

async function PostJSONWithFileResponse(url, payload) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  };
  var resp;
  try {
    resp = await fetch(url, requestOptions);
    return await resp.blob();
  } catch (error) {
    throw new Error({
      reseponseStatus: resp.status,
    });
  }
}

async function DeleteJSON(url) {
  const requestOptions = { method: 'DELETE', headers: { Accept: 'application/json' }, credentials: 'include' };
  var resp;
  try {
    resp = await fetch(url, requestOptions);
    return await resp.json();
  } catch (e) {
    throw new Error({ responseStatus: resp.status });
  }
}

// #region Binary files

async function PostBinary(url, file) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/octet-stream' },
    credentials: 'include',
    body: file,
  };
  const resp = await fetch(url, requestOptions);
  const json = await resp.json();
  return json;
}

async function GetBinary(url) {
  const requestOptions = {
    method: 'GET',
    headers: { Accept: 'application/octet-stream' },
    credentials: 'include',
  };
  var resp = await fetch(url, requestOptions);
  return resp;
}
// #endregion Binary files

// #region JPK
export async function SearchUs(searchString) {
  return await GetJSON(urls().GetUSList + '?searchString=' + encodeURIComponent(searchString) + '&limit=10');
}
// #endregion